import type { RouteRecordRaw } from 'vue-router'

import { registerDashboardMessages } from './i18n'

import { useLocaleStore } from '@/shared/i18n'

async function loadMessages(): Promise<void> {
  await registerDashboardMessages(useLocaleStore().locale)
}

/**
 * The four production dashboard ingresses move as one cutover unit (ORP-18667). The preview
 * paths remain aliases for additive rollback/readiness links; route names stay identical to v3
 * so guards, navigation contributions and save/delete redirects need no proxy-only branching.
 */
export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: 'custom-dashboard/create-new',
    alias: '__preview/custom-dashboard/create-new',
    name: 'CustomDashboardCreate',
    component: () => import('./components/pages/DashboardPage.vue'),
    meta: dashboardMeta(),
    beforeEnter: loadMessages,
  },
  {
    path: String.raw`:account_id(\d+)/:workspace_id(\d+)/:url`,
    alias: String.raw`__preview/custom-dashboard/:account_id(\d+)/:workspace_id(\d+)/:url`,
    name: 'CustomDashboard',
    component: () => import('./components/pages/DashboardPage.vue'),
    meta: dashboardMeta(),
    beforeEnter: loadMessages,
  },
  {
    path: 'custom-dashboard/:url?',
    alias: '__preview/custom-dashboard/:url?',
    name: 'CustomDashboardLegacy',
    component: () => import('./components/pages/DashboardPage.vue'),
    meta: dashboardMeta(),
    beforeEnter: loadMessages,
  },
  {
    path: 'account-center/:url?',
    alias: '__preview/account-center/:url?',
    name: 'AccountCenter',
    component: () => import('./components/pages/AccountCenterPage.vue'),
    meta: {
      ...dashboardMeta(),
      navKey: 'accountCenter',
      titleKey: 'dashboards.page.accountCenter',
      requiresAccountCenterAccess: true,
    },
    beforeEnter: loadMessages,
  },
]

function dashboardMeta(): NonNullable<RouteRecordRaw['meta']> {
  return {
    requiresAuth: true,
    navKey: 'dashboards',
    titleKey: 'dashboards.page.dashboard',
    contentInset: 'none',
  }
}
